import React from 'react';
import { 
  KnowledgeMapIconIds,
} from 'constants/knowledgeMap';
import { 
  KnowledgeMapDownloadLink,
  DownloadButton,
} from './styles';

const KnowledgeMapDownloadButton = (props) => (
  <DownloadButton primary {...props}>
    <KnowledgeMapDownloadLink
      icon={KnowledgeMapIconIds.FILE_DOWNLOAD}
    />
  </DownloadButton>
);

export default KnowledgeMapDownloadButton;
